(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/router.js');
"use strict";


const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  baseUrl
} = svs.core.data;
const {
  OrderHomeRouter,
  SubscriptionRouter
} = svs.ticketsOrderHome;
const {
  Divider
} = svs.ticketsOrderHome.pages;
const {
  DIVIDER
} = svs.ticketsOrderHome.routes;
const {
  ScrollToTop
} = svs.ticketsOrderHome.components;
const Router = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(ScrollToTop, null), React.createElement(Route, {
  component: Divider,
  exact: true,
  path: DIVIDER
}), React.createElement(OrderHomeRouter, null), React.createElement(SubscriptionRouter, null));
setGlobal('svs.ticketsOrderHome.router', Router);
const container = document.getElementById('reactContainer');
container && ReactDOM.render(React.createElement(Router, null), container);

 })(window);